/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
export const protobufPackage = "mboot";
export var WAN;
(function (WAN) {
    WAN["WAN_UNKNOWN"] = "WAN_UNKNOWN";
    WAN["WAN_0"] = "WAN_0";
    WAN["WAN_1"] = "WAN_1";
})(WAN || (WAN = {}));
export var IPProtocol;
(function (IPProtocol) {
    IPProtocol["IP_UNKNOWN"] = "IP_UNKNOWN";
    IPProtocol["IP_TCP"] = "IP_TCP";
    IPProtocol["IP_UDP"] = "IP_UDP";
    IPProtocol["IP_ICMP"] = "IP_ICMP";
})(IPProtocol || (IPProtocol = {}));
export var GuestPasswordStrategy;
(function (GuestPasswordStrategy) {
    /**
     * UNKNOWN - Enum keys are global - not just unique to this. You can't change these
     * values since the string names - "UNKNOWN" etc - are what's stored in the
     * mboot config files.
     */
    GuestPasswordStrategy["UNKNOWN"] = "UNKNOWN";
    GuestPasswordStrategy["NEVER"] = "NEVER";
    GuestPasswordStrategy["DAILY"] = "DAILY";
    GuestPasswordStrategy["MONTHLY"] = "MONTHLY";
    GuestPasswordStrategy["WEEKLY"] = "WEEKLY";
})(GuestPasswordStrategy || (GuestPasswordStrategy = {}));
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
